<!-- <div class="product-card" [ngClass]="{
    'product-card--layout--grid product-card--size--sm': layout === 'grid-sm',
    'product-card--layout--grid product-card--size--nl': layout === 'grid-nl',
    'product-card--layout--grid product-card--size--lg': layout === 'grid-lg',
    'product-card--layout--list':                        layout === 'list',
    'product-card--layout--horizontal':                  layout === 'horizontal'
}">
    <div class="product-property-card__image product-image">
        <owl-carousel-o *ngIf="!_.isEmpty(product.images)" [options]="options" appOwlPreventClick>
            <ng-template *ngFor="let item of product.images|keyvalue" carouselSlide>
                <a appClick [routerLink]="routerLinkString()" class="product-image__body">
                    <img class="product-image__img" [src]="item.value?.url" alt="">
                </a>
            </ng-template>
        </owl-carousel-o>
        <a *ngIf="_.isEmpty(product.images)" appClick [routerLink]="routerLinkString()" class="product-image__body">
            <img class="product-image__img" [src]="image" alt="">
        </a>
    </div>
    <div class="product-card__info">
        <div class="product-card__name">
            <a appClick [routerLink]="routerLinkString()">{{ product?.name?.en }}</a>
        </div>

        <ul *ngIf="featuredAttributes.length" class="product-card__features-list">
            <li *ngFor="let attribute of featuredAttributes">
                {{ attribute.name }}:
                <ng-container *ngFor="let value of attribute.values; let last = last">
                    {{ value.name }}<ng-container *ngIf="!last">, </ng-container>
                </ng-container>
            </li>
        </ul>
    </div>
    <div class="product-card__actions hidden sm:block">
            <a  appClick [routerLink]="routerLinkString()" class="product-image__body">
                <img class="product-image__img" [src]="(companyData?.design?.logo?.url) ? companyData?.design?.logo?.url : image" alt="">
            </a>
            <p class="text-center">{{companyData?.name?.en}}</p>
    </div>
</div> -->

<div class="product-property-card">
    <div class="product-property-image-body">
        <owl-carousel-o *ngIf="!_.isEmpty(product.images)" [options]="options" appOwlPreventClick>
            <ng-template *ngFor="let item of product.images|keyvalue" carouselSlide>

                <a class="product-property-image" [routerLink]="routerLinkString()" [ngStyle]="{backgroundImage:'url('+item.value?.url+')'}" appClick></a>
            </ng-template>
        </owl-carousel-o>
        <a class="product-property-image" *ngIf="_.isEmpty(product.images)" appClick [ngStyle]="{backgroundImage:'url('+image+')'}" [routerLink]="routerLinkString()">
        </a>
    </div>

    <div class="product-property-content">

        <div class="product-property-price">
            <ng-container *ngIf="product?.realEstate?.displayPrice">
                <div class="flex flex-row text-xl  font-bold">
                    <div>
                        <ng-container *ngIf="product?.realEstate?.displayPrice?.priceType == 'exact'">
                            <span class="price-color">{{product?.realEstate?.displayPrice?.price|currencyFormat}}</span>
                        </ng-container>
                        <ng-container *ngIf="product?.realEstate?.displayPrice?.priceType == 'range'">
                            <span class="price-color">{{product?.realEstate?.displayPrice?.priceRange?.min|currencyFormat}}
                                -
                                {{product?.realEstate?.displayPrice?.priceRange?.max|currencyFormat}}</span>
                        </ng-container>
                        <ng-container *ngIf="product?.realEstate?.displayPrice?.priceType == 'from'">
                            <span class="price-color">{{"starting_from"|translate}}
                                {{product?.realEstate?.displayPrice?.price|currencyFormat}}</span>
                        </ng-container>
                    </div>
                    <div class="font-bold text-lg" *ngIf="product?.realEstate?.displayPrice?.propertyType =='rent' && product.realEstate?.displayPrice?.rentType">
                        /{{product?.realEstate?.displayPrice?.rentType|uppercase}}
                    </div>
                </div>
                <label>{{translateHelper.localize(product.realEstate?.displayPrice?.priceLabel)}}</label>
            </ng-container>
            <ng-container *ngIf="!product?.realEstate?.displayPrice">
                {{product?.price|currencyFormat}}
            </ng-container>
        </div>
        <div class="product-property-name">
            {{product?.name?.en}}
        </div>
        <!-- <div [innerHTML]="product?.description?.en"></div> -->
        <div class="product-property-properties">
            <ng-container *ngFor="let property of product?.subtype?.properties">
                <div class="property-name  font-bold">
                    {{property?.name?.en}} :
                </div>
                <span class="ms-2"><i [class]="property.icon"> </i></span>
                <div class="property-value ms-2">
                    <ng-container *ngIf="property.type=='checkbox' && property.value">
                        <span *ngIf="property.value=='true'"><i class="fas fa-check"></i></span>
                        <span *ngIf="property.value=='false'"><i class="fas fa-times"></i></span>
                    </ng-container>
                    <ng-container *ngIf="property.type=='list' && property.value">
                        <span>{{property.value?.name?.en}}</span>
                    </ng-container>
                </div>

            </ng-container>
        </div>
        <div class="product-property-view">
            <button class="btn btn-primary" eventCollector eventName="view_item" category="catalog" itemType="property" [companyId]="product.companyData?._id" [productId]="product._id" [routerLink]="routerLinkString()">View Item</button>
        </div>
    </div>

    <div class="product-property-vendor">
        <a class="text-center font-bold" [routerLink]="((sector) ? ['/sector', sector] : ['/']).concat(['vendor', companyData?.seo?.slug])">{{companyData?.name?.en}}</a>
    </div>
</div>